import { useCallback, useContext, useMemo } from 'react';
import { CityContext } from '../ContextApi/cityContext';

// הסינון והסדר של רשימות העסקים לפי המקום והעיר של הלקוח נעשים בשרת
// (server: DTechComp/placeRelevance.js; הבקשות שולחות placeParams מ-ContextApi/cityContext.js).
// כאן רק התגית "לא מגיע ל...": עסק עם רשימת ערים למשלוח שהעיר שלי לא בה.
// עסק בלי רשימה (למשל חברת שליחויות חיצונית) לא מסומן - אין לנו מידע לאן הוא מגיע.

// כמו geoCities.normCityName בשרת
const normName = (s) => String(s || '').trim()
    .replace(/[-־]/g, ' ').replace(/["'״׳]/g, '').replace(/\s+/g, ' ');

const usePlaceRelevance = () => {
    const ctx = useContext(CityContext) || {};
    const { city: place, myCity } = ctx;

    const scope = useMemo(() => {
        if (!place) return null;
        // מרחב בלי עיר בפועל - כל ערי המרחב נחשבות "שלי"
        const mine = myCity ? [myCity] : (Array.isArray(place.cities) ? place.cities : []);
        if (!mine.length) return null;
        return { label: myCity ? myCity.name : place.name, myNames: new Set(mine.map(c => normName(c.name))) };
    }, [place, myCity]);

    const notDeliveringTxt = useCallback((item) => {
        if (!scope || !item) return '';
        const names = (Array.isArray(item.cityesToDeliver) ? item.cityesToDeliver : [])
            .map(e => e && normName(e.cityName)).filter(Boolean);
        if (!names.length || names.some(n => scope.myNames.has(n))) return '';
        return `לא מגיע ל${scope.label}`;
    }, [scope]);

    return { notDeliveringTxt };
};

export default usePlaceRelevance;

// השרת מסמן כל עסק ב-placeRank (0 - מגיע אליי, 1 - במרחב ולא מגיע, 2 - בלי עיר).
// אחרי ערבוב / "סגורים בסוף" בצד הלקוח - מחזיר את הסדר לפי הדרגה (מיון יציב: הסדר בתוך דרגה נשמר).
// rankOf - כשהדרגה לא על הפריט עצמו (ברירת מחדל: item.placeRank)
export const byPlaceRank = (list, rankOf = (x) => x && x.placeRank) => {
    if (!Array.isArray(list)) return list;
    return list.map((x, i) => [x, i])
        .sort((a, b) => ((rankOf(a[0]) || 0) - (rankOf(b[0]) || 0)) || (a[1] - b[1]))
        .map(p => p[0]);
};
